import { Injectable, signal } from '@angular/core';

import { TFormatPriceOptions } from './format-price.type';

@Injectable({
  providedIn: 'root',
})
export class SntFormatPriceService {
  private _decimalDigits!: number;

  readonly options = signal<TFormatPriceOptions>({});

  set decimalDigits(value: number) {
    this._decimalDigits = value;
    this.options.update((options) => ({ ...options, decimalDigits: value }));
  }

  get decimalDigits(): number {
    return this._decimalDigits;
  }
}
